// WithClipMessage.js
import { connect } from 'react-redux';

import {
  SHORT_VIDEO_LENGTH_MIN,
  POST_VIDEO_LENGTH_MIN,
} from '../RemoteConfigKeys.js';

import withRouter from '../component/WithRouter.jsx';

import WithClipMessage from '../component/WithClipMessage.jsx';

import toggleModal from '../action/toggleModal.js';
import pushToastr from '../action/pushToastr.js';

import getMessageDuration from '../selector/getMessageDuration.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';

const mapStateToProps = (state, { messageId }) => {
  const meId = getMeData(state, 'id');
  return {
    meId,
    messageId,
    duration: getMessageDuration(state, messageId),
    postVideoDurationMin: getRemoteConfigData(state, POST_VIDEO_LENGTH_MIN),
    clipDurationMin: getRemoteConfigData(state, SHORT_VIDEO_LENGTH_MIN),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: data => dispatch(toggleModal(data)),
    pushToastr: data => dispatch(pushToastr(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithClipMessage)
);
